/* eslint-disable max-len */
import axios, { AxiosResponse } from "axios";
import { ILogin, IForgotPassword, IResetPassword, IUpdateUser } from "../models/auth.model";

export const login = async (payload: ILogin) => {
  const res = await axios.post("/user/login", payload);
  return res;
};

export const verifyCode = async (payload: { email: string; verification_code: string }) => {
  const res = await axios.post("/user/verify-code", payload);
  return res;
};

export const forgotPassword = async (payload: IForgotPassword) => {
  const res = await axios.post("/user/forget-password", payload);
  return res;
};

export const resetPassword = async (payload: IResetPassword) => {
  const res = await axios.post("/user/verify-forget-password", payload);
  return res;
};

export const getUserInfor = async () => {
  return await axios.get("/user/info");
};

export const resendVerificationCode = async (email: string) => {
  const res = await axios.post("/user/resend-verification-code", {
    email,
  });
  return res;
};

export const updateUserInfor = async (payload: IUpdateUser) => {
  const res = await axios.patch("/user/update-profile", payload);
  return res;
};

export const switchCompany = async (companyId: string) => {
  const res = await axios.post("/user/switch-company", { company_id: companyId });
  return res;
};